export type AlertaCiencia = {
  titulo?: string;
  mensagem?: string;
};

type Ouvinte = () => void;

const chaveDoAlerta = (alerta: AlertaCiencia) =>
  `${alerta?.titulo || ""}|${alerta?.mensagem || ""}`;

let fila: AlertaCiencia[] = [];
let ouvintes: Ouvinte[] = [];

// Alertas já exibidos que seguem ativos, agrupados por fonte. Uma fonte é cada
// chamada que reenvia seus alertas a cada requisição (resumo-pagamento,
// gerar-fluxo). Guardar por fonte evita que a ausência de um alerta em uma
// delas re-arme um alerta que continua ativo na outra.
const exibidosPorFonte = new Map<string, Set<string>>();

const notificar = () => {
  ouvintes.forEach((ouvinte) => ouvinte());
};

const enfileirar = (alertas: AlertaCiencia[]) => {
  const novos = alertas.filter(
    (alerta) =>
      (alerta?.titulo || alerta?.mensagem) &&
      !fila.some((naFila) => chaveDoAlerta(naFila) === chaveDoAlerta(alerta))
  );

  if (novos.length === 0) return;

  fila = [...fila, ...novos];
  notificar();
};

/** Exibe um aviso que exige confirmação explícita do usuário. */
export const mostrarAlertaCiencia = (
  alertas: AlertaCiencia | AlertaCiencia[]
) => {
  enfileirar(Array.isArray(alertas) ? alertas : [alertas]);
};

/**
 * Para alertas de negócio que o backend reenvia a cada chamada: exibe apenas os
 * que o usuário ainda não confirmou. Um alerta que some da resposta é esquecido,
 * então volta a avisar caso apareça de novo.
 */
export const sincronizarAlertasDaEtapa = (
  fonte: string,
  alertas?: AlertaCiencia[]
) => {
  const lista = alertas || [];
  const exibidos = exibidosPorFonte.get(fonte) || new Set<string>();
  const novos = lista.filter((alerta) => !exibidos.has(chaveDoAlerta(alerta)));

  exibidosPorFonte.set(fonte, new Set(lista.map(chaveDoAlerta)));
  enfileirar(novos);
};

/** Converte o erro de uma chamada em aviso confirmável. */
export const notificarErroApi = (contexto: string, error: any) => {
  const mensagens = (error?.response?.data?.notifications || [])
    .map((item: any) => item?.message)
    .filter(Boolean);

  mostrarAlertaCiencia(
    mensagens.length > 0
      ? mensagens.map((mensagem: string) => ({ titulo: contexto, mensagem }))
      : [{ titulo: contexto, mensagem: "Erro na conexão com o servidor." }]
  );
};

export const confirmarAlertasCiencia = () => {
  fila = [];
  notificar();
};

/** Limpa fila e histórico, para que uma nova visita à tela volte a avisar. */
export const resetarAlertasCiencia = () => {
  fila = [];
  exibidosPorFonte.clear();
  notificar();
};

export const inscreverAlertasCiencia = (ouvinte: Ouvinte) => {
  ouvintes = [...ouvintes, ouvinte];
  return () => {
    ouvintes = ouvintes.filter((item) => item !== ouvinte);
  };
};

export const obterAlertasCiencia = () => fila;
